import React, { useState } from "react";
import { Button, Input, Modal } from "rizzui";
import FormLabel from "../../../components/forms/FormLabel";

interface AddSpecieModalProps {
    isOpen: boolean;
    setIsOpen: (isOpen: boolean) => void;
    setSpeciesWithQuantities: any;
    selectedSpecie: any;
}

export const AddSpecieModal: React.FC<AddSpecieModalProps> = ({ isOpen, setIsOpen, setSpeciesWithQuantities, selectedSpecie }) => {

    // STATES

    const [currentQuantity, setCurrentQuantity] = useState('1');

    // FUNCTIONS

    // RENDER

    return (
        <Modal
            isOpen={isOpen}
            onClose={() => {
                setIsOpen(false);
                setCurrentQuantity('1');
            }}
            size='sm'
            overlayClassName='backdrop-blur'
            containerClassName='!max-w-xl !shadow-xl'
            className='z-[9999] [&_.pointer-events-none]:overflow-visible'
        >
            <div className='flex items-center justify-between p-4'>
                <h2 className='text-lg font-semibold text-gray-800 dark:text-white'>
                    Cantidad para <i>{selectedSpecie?.label}</i>
                </h2>
                <button onClick={
                    () => {
                        setIsOpen(false);
                        setCurrentQuantity('1');
                    }
                } className='text-gray-500 hover:text-gray-700 dark:hover:text-gray-300'>
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                    </svg>
                </button>
            </div>
            <div className='m-auto px-7 pt-6 pb-4'>
                <FormLabel label="Cantidad" required={true} >
                    <Input
                        type="number"
                        value={currentQuantity}
                        onChange={(e) => setCurrentQuantity(e.target.value)}
                        placeholder="Ingrese cantidad"
                        className="form-control"
                    />
                </FormLabel>
            </div>

            <div className='flex justify-between p-7'>
                <Button 
                    color="danger" 
                    onClick={() => setIsOpen(false)}
                >
                    Cancelar
                </Button>
                <Button
                    onClick={() => {
                        setSpeciesWithQuantities((prev: any) => [
                            ...prev,
                            {
                                ...selectedSpecie,
                                numIndividuals: currentQuantity,
                                label: `${selectedSpecie.label} (${currentQuantity})`,
                                commonName: selectedSpecie.commonName,
                            }
                        ]);
                        setIsOpen(false);
                        setCurrentQuantity('1');
                    }}
                    color='primary'
                >
                    Agregar
                </Button>
            </div>
        </Modal>
    );
};

export default AddSpecieModal;
